import type { Location, NavigateFunction } from 'react-router-dom';

const modifyStateField =
  (method: 'push' | 'replace'): HistoryStateFieldUpdateFunction =>
  (navigate, location, update) => {
    const state = (location.state as any) ?? {};
    navigate(location.pathname, {
      state: {
        ...state,
        ...update,
      },
      replace: method === 'replace',
    });
  };

type HistoryStateFieldUpdateFunction = <
  HistoryLocationState extends
    HistoryStateFieldUpdateFunction = HistoryStateFieldUpdateFunction,
>(
  navigate: NavigateFunction,
  location: Location,
  update: Partial<HistoryLocationState>,
) => void;

export const pushHistoryStateField: HistoryStateFieldUpdateFunction =
  modifyStateField('push');
export const replaceHistoryStateField: HistoryStateFieldUpdateFunction =
  modifyStateField('replace');
